import { IUserSubscriptionModel } from "@nf/common";
import { useMemo } from "react";

type TCurrentSubscriptions = {
  currentSubscriptions: undefined | IUserSubscriptionModel[];
  hasCurrentSubscriptions: boolean;
};

export const useCurrentSubscriptions = (
  subscriptions?: IUserSubscriptionModel[]
): TCurrentSubscriptions => {
  const currentActiveSubscriptions =
    (subscriptions && subscriptions.length > 0) || false;

  const currentSubscriptions = useMemo(() => {
    return currentActiveSubscriptions && subscriptions
      ? subscriptions
          .filter(
            (subscription) => subscription.IsActive || subscription.IsPaused
          )
          .sort(
            (a: IUserSubscriptionModel, b: IUserSubscriptionModel) =>
              new Date(b.ExpirationDate).getTime() -
              new Date(a.ExpirationDate).getTime()
          )
          .sort(
            (a: IUserSubscriptionModel, b: IUserSubscriptionModel) =>
              Number(!!b.Partner) - Number(!!a.Partner)
          )
      : undefined;
  }, [subscriptions, currentActiveSubscriptions]);

  const hasCurrentSubscriptions =
    (currentSubscriptions && currentSubscriptions.length > 0) || false;
  return {
    currentSubscriptions,
    hasCurrentSubscriptions,
  };
};
